module.exports = __webpack_public_path__ + "static/media/maestro-logo.c8dae6b5.svg";